export const opportunityType = function ($opportunitiesAvailable) {
  return function (input, message) {
    return !!$opportunitiesAvailable.get(input)
      ? $opportunitiesAvailable.get(input).title
      : input;
  };
};

opportunityType.$inject = ["$opportunitiesAvailable"];
